import { Component, Input } from '@angular/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';
import { TranslateModule } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageContent, MessageUtil } from './message.util';
import { NotFoundComponent } from './not-found/not-found.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  imports: [ZenithComponentsModule, TranslateModule, NotFoundComponent, UnauthorizedComponent],
  standalone: true
})
export class ErrorComponent {
  @Input() error: Error | HttpErrorResponse;

  get content(): MessageContent {
    return MessageUtil.toContent(this.error);
  }
}
